import React from 'react';
import { motion } from 'framer-motion';
export function TienCharacter() {
  return <motion.div animate={{
    y: [0, -6, 0]
  }} transition={{
    duration: 3,
    repeat: Infinity,
    ease: 'easeInOut'
  }} className="hidden md:block absolute left-1/2 -translate-x-1/2 -top-16 z-0 pointer-events-none" data-id="element-31">
      <svg width="140" height="200" viewBox="0 0 140 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-32">
        {/* Shadow under character */}
        <ellipse cx="70" cy="196" rx="35" ry="4" fill="#e5e7eb" opacity="0.5" data-id="element-33" />

        {/* Body - Black hoodie */}
        <path d="M40 130 C40 115, 50 105, 70 102 C90 105, 100 115, 100 130 L105 200 L35 200 Z" fill="#1a1a1a" data-id="element-34" />
        {/* Hoodie neckline */}
        <path d="M58 108 C62 114, 65 116, 70 117 C75 116, 78 114, 82 108" stroke="#333" strokeWidth="1.5" fill="none" data-id="element-35" />
        {/* Hoodie pocket */}
        <rect x="52" y="150" width="36" height="16" rx="8" fill="#222" opacity="0.3" data-id="element-36" />

        {/* Hoodie strings */}
        <line x1="64" y1="112" x2="62" y2="135" stroke="#444" strokeWidth="1" data-id="element-37" />
        <line x1="76" y1="112" x2="78" y2="135" stroke="#444" strokeWidth="1" data-id="element-38" />

        {/* Medal lanyards - blue */}
        <path d="M60 108 L52 155" stroke="#3b82f6" strokeWidth="2.5" data-id="element-39" />
        <path d="M80 108 L88 155" stroke="#3b82f6" strokeWidth="2.5" data-id="element-40" />
        {/* Second lanyard set */}
        <path d="M62 108 L56 150" stroke="#60a5fa" strokeWidth="2" data-id="element-41" />
        <path d="M78 108 L84 150" stroke="#60a5fa" strokeWidth="2" data-id="element-42" />

        {/* Hands holding medals */}
        {/* Left hand */}
        <ellipse cx="53" cy="156" rx="7" ry="5" fill="#e8b88a" data-id="element-43" />
        {/* Right hand */}
        <ellipse cx="87" cy="156" rx="7" ry="5" fill="#e8b88a" data-id="element-44" />

        {/* Gold medal */}
        <circle cx="53" cy="162" r="8" fill="#fbbf24" stroke="#f59e0b" strokeWidth="1.5" data-id="element-45" />
        <circle cx="53" cy="162" r="5" fill="#fcd34d" data-id="element-46" />
        <text x="53" y="165" textAnchor="middle" fontSize="7" fill="#92400e" fontWeight="bold" data-id="element-47">
          1
        </text>

        {/* Silver medal */}
        <circle cx="87" cy="162" r="8" fill="#d1d5db" stroke="#9ca3af" strokeWidth="1.5" data-id="element-48" />
        <circle cx="87" cy="162" r="5" fill="#e5e7eb" data-id="element-49" />
        <text x="87" y="165" textAnchor="middle" fontSize="7" fill="#4b5563" fontWeight="bold" data-id="element-50">
          2
        </text>

        {/* Neck */}
        <rect x="63" y="95" width="14" height="14" rx="4" fill="#e8b88a" data-id="element-51" />

        {/* Head */}
        <ellipse cx="70" cy="62" rx="32" ry="36" fill="#f0c9a0" data-id="element-52" />

        {/* Hair - back layer (long, past shoulders) */}
        <path d="M36 55 C34 70, 32 100, 35 140 C36 145, 38 148, 42 148 C44 140, 42 110, 43 80 L38 55 Z" fill="#2d1810" data-id="element-53" />
        <path d="M104 55 C106 70, 108 100, 105 140 C104 145, 102 148, 98 148 C96 140, 98 110, 97 80 L102 55 Z" fill="#2d1810" data-id="element-54" />

        {/* Hair - main top */}
        <path d="M38 52 C38 28, 50 16, 70 14 C90 16, 102 28, 102 52 C102 58, 100 62, 98 65 L97 55 C96 42, 88 32, 70 30 C52 32, 44 42, 43 55 L42 65 C40 62, 38 58, 38 52 Z" fill="#3b2317" data-id="element-55" />

        {/* Bangs */}
        <path d="M42 48 C44 38, 50 30, 58 28 L56 52 C52 52, 46 52, 42 48 Z" fill="#3b2317" data-id="element-56" />
        <path d="M56 27 C62 25, 66 25, 70 26 L66 52 L56 52 Z" fill="#3b2317" data-id="element-57" />
        <path d="M70 26 C74 25, 78 25, 84 27 L84 52 L74 52 Z" fill="#3b2317" data-id="element-58" />
        <path d="M84 28 C90 30, 96 38, 98 48 C94 52, 88 52, 84 52 Z" fill="#3b2317" data-id="element-59" />

        {/* Side hair strands */}
        <path d="M38 55 C36 65, 35 80, 36 100 C36 115, 37 130, 38 140" stroke="#3b2317" strokeWidth="8" fill="none" strokeLinecap="round" data-id="element-60" />
        <path d="M102 55 C104 65, 105 80, 104 100 C104 115, 103 130, 102 140" stroke="#3b2317" strokeWidth="8" fill="none" strokeLinecap="round" data-id="element-61" />

        {/* Eyes */}
        {/* Left eye */}
        <ellipse cx="57" cy="65" rx="5" ry="5.5" fill="white" data-id="element-62" />
        <ellipse cx="58" cy="65.5" rx="3" ry="3.5" fill="#2d1810" data-id="element-63" />
        <circle cx="59" cy="64" r="1.2" fill="white" data-id="element-64" />

        {/* Right eye */}
        <ellipse cx="83" cy="65" rx="5" ry="5.5" fill="white" data-id="element-65" />
        <ellipse cx="82" cy="65.5" rx="3" ry="3.5" fill="#2d1810" data-id="element-66" />
        <circle cx="83" cy="64" r="1.2" fill="white" data-id="element-67" />

        {/* Eyebrows */}
        <path d="M51 57 C54 54, 59 54, 63 56" stroke="#3b2317" strokeWidth="1.8" fill="none" strokeLinecap="round" data-id="element-68" />
        <path d="M77 56 C81 54, 86 54, 89 57" stroke="#3b2317" strokeWidth="1.8" fill="none" strokeLinecap="round" data-id="element-69" />

        {/* Nose */}
        <path d="M68 72 C69 74, 71 74, 72 72" stroke="#d4a07a" strokeWidth="1.2" fill="none" strokeLinecap="round" data-id="element-70" />

        {/* Smile */}
        <path d="M60 80 C64 86, 76 86, 80 80" stroke="#c47a5a" strokeWidth="2" fill="none" strokeLinecap="round" data-id="element-71" />
        {/* Smile fill for friendly look */}
        <path d="M62 81 C65 85, 75 85, 78 81" fill="#e88a7a" opacity="0.3" data-id="element-72" />

        {/* Blush */}
        <ellipse cx="50" cy="76" rx="5" ry="3" fill="#f4a0a0" opacity="0.35" data-id="element-73" />
        <ellipse cx="90" cy="76" rx="5" ry="3" fill="#f4a0a0" opacity="0.35" data-id="element-74" />

        {/* Ears */}
        <ellipse cx="38" cy="65" rx="4" ry="6" fill="#e8b88a" data-id="element-75" />
        <ellipse cx="102" cy="65" rx="4" ry="6" fill="#e8b88a" data-id="element-76" />
      </svg>
    </motion.div>;
}